import { render, staticRenderFns } from "./SocialContactDisplay.vue?vue&type=template&id=73d138a4&scoped=true"
import script from "./SocialContactDisplay.vue?vue&type=script&lang=js"
export * from "./SocialContactDisplay.vue?vue&type=script&lang=js"
import style0 from "./SocialContactDisplay.vue?vue&type=style&index=0&id=73d138a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d138a4",
  null
  
)

export default component.exports